var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getContractBasic } from '@portkey/contracts';
import { ChainIdMap, LoginStatusEnum, } from '@portkey/types';
import { aes, aelf } from '@portkey/utils';
import { BaseDIDWallet, } from './types.js';
import AElf from 'aelf-sdk';
export class DIDWallet extends BaseDIDWallet {
    constructor({ accountProvider, storage, service, connectService, }) {
        super(accountProvider, storage);
        this._defaultKeyName = 'portkey_sdk_did_wallet_v2';
        this.services = service;
        this.connectServices = connectService;
        this.contracts = {};
        this.caInfo = {};
        this.accountInfo = {};
        this.aaInfo = {};
        this.isLoginStatus = LoginStatusEnum.INIT;
        this.sessionId = '';
    }
    getVerifierServers(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.services.getVerifierServers(chainId);
            return result.guardianVerifierServers;
        });
    }
    login(type, params) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.managementAccount)
                this.create();
            if (type === 'scan') {
                if (!this.accountInfo.loginAccount)
                    throw new Error('account not logged in');
                const _params = params;
                const req = yield this.addManager(_params);
                if (req === null || req === void 0 ? void 0 : req.error)
                    throw req.error;
                return true;
            }
            else {
                if (this.accountInfo.loginAccount)
                    throw new Error('account already exists');
                const _params = params;
                const { sessionId } = yield this.services.recovery(Object.assign(Object.assign({}, _params), { manager: (_a = this.managementAccount) === null || _a === void 0 ? void 0 : _a.address }));
                this.sessionId = sessionId;
                let status, error;
                try {
                    status = yield this.services.getRecoverStatus(sessionId);
                    const { caAddress, caHash, recoveryStatus } = status;
                    if (recoveryStatus === 'pass') {
                        this.accountInfo = { loginAccount: _params.loginGuardianIdentifier };
                        this.caInfo[_params.chainId] = { caAddress, caHash };
                    }
                    else {
                        throw new Error(status.recoveryMessage);
                    }
                }
                catch (e) {
                    error = e;
                }
                return { sessionId, status, error };
            }
        });
    }
    getLoginStatus({ sessionId, chainId, }) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const status = yield this.services.getRecoverStatus(sessionId);
            if ((status === null || status === void 0 ? void 0 : status.recoveryStatus) === 'pass' && ((_a = this.managementAccount) === null || _a === void 0 ? void 0 : _a.address) && !((_b = this.caInfo) === null || _b === void 0 ? void 0 : _b[chainId])) {
                this.accountInfo = { loginAccount: status.caHash };
                this.caInfo[chainId] = { caAddress: status.caAddress, caHash: status.caHash };
                this.aaInfo = { accountInfo: { caAddress: status.caAddress, caHash: status.caHash } };
                this.originChainId = chainId;
            }
            if ((status === null || status === void 0 ? void 0 : status.recoveryStatus) === 'pass') {
                this.isLoginStatus = LoginStatusEnum.SUCCESS;
            }
            return status;
        });
    }
    register(params) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.accountInfo.loginAccount)
                throw new Error('account already exists');
            if (!this.managementAccount)
                this.create();
            const { sessionId } = yield this.services.register(Object.assign(Object.assign({}, params), { manager: (_a = this.managementAccount) === null || _a === void 0 ? void 0 : _a.address }));
            this.sessionId = sessionId;
            let status, error;
            try {
                status = yield this.services.getRegisterStatus(sessionId);
                const { caAddress, caHash, registerStatus } = status;
                if (registerStatus === 'pass') {
                    this.accountInfo = { loginAccount: params.loginGuardianIdentifier };
                    this.caInfo[params.chainId] = { caAddress, caHash };
                }
                else {
                    throw new Error(status.registerMessage);
                }
            }
            catch (e) {
                error = e;
            }
            return { sessionId, status, error };
        });
    }
    getRegisterStatus({ sessionId, chainId, }) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const status = yield this.services.getRegisterStatus(sessionId);
            if ((status === null || status === void 0 ? void 0 : status.registerStatus) === 'pass' && ((_a = this.managementAccount) === null || _a === void 0 ? void 0 : _a.address) && !((_b = this.caInfo) === null || _b === void 0 ? void 0 : _b[chainId])) {
                this.accountInfo = { loginAccount: status.caHash };
                this.aaInfo = { accountInfo: { caAddress: status.caAddress, caHash: status.caHash } };
                this.originChainId = chainId;
                this.caInfo[chainId] = { caAddress: status.caAddress, caHash: status.caHash };
            }
            if ((status === null || status === void 0 ? void 0 : status.registerStatus) === 'pass') {
                this.isLoginStatus = LoginStatusEnum.SUCCESS;
            }
            return status;
        });
    }
    saveTempStatus({ chainId, caAddress, caHash, sessionId, }) {
        this.accountInfo = { loginAccount: caHash };
        this.aaInfo = { accountInfo: { caAddress: caAddress, caHash: caHash } };
        this.originChainId = chainId;
        this.caInfo[chainId] = { caAddress: caAddress, caHash: caHash };
        this.sessionId = sessionId;
    }
    getVerifierServersByContract(chainId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.managementAccount)
                this.create();
            const contract = yield this.getContractByChainInfo(chainId);
            const req = yield contract.callViewMethod('GetVerifierServers', '');
            if (req.error)
                throw req.error;
            return (_a = req.data) === null || _a === void 0 ? void 0 : _a.verifierServers;
        });
    }
    getContract({ contractAddress, rpcUrl }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.managementAccount)
                throw new Error('managerAccount does not exist');
            const key = contractAddress + rpcUrl + this.managementAccount.address;
            if (!this.contracts[key])
                this.contracts[key] = yield getContractBasic({
                    account: this.managementAccount.wallet,
                    rpcUrl,
                    contractAddress,
                });
            return this.contracts[key];
        });
    }
    getContractByChainInfo(chainId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.chainsInfo)
                yield this.getChainsInfo();
            const chainInfo = (_a = this.chainsInfo) === null || _a === void 0 ? void 0 : _a[chainId];
            if (!chainInfo)
                throw new Error(`${chainId} chainInfo does not exist`);
            return this.getContract({
                contractAddress: chainInfo.caContractAddress,
                rpcUrl: chainInfo.endPoint,
            });
        });
    }
    addManager(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.managementAccount)
                throw new Error('managerAccount does not exist');
            const { chainId } = params, contractParams = __rest(params, ["chainId"]);
            const contract = yield this.getContractByChainInfo(chainId);
            const req = yield contract.callSendMethod('AddManagerInfo', this.managementAccount.address, contractParams);
            if (req.error)
                throw req.error;
            return req.data;
        });
    }
    removeManager(params, sendOption) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.managementAccount)
                throw new Error('managerAccount does not exist');
            const { chainId } = params, contractParams = __rest(params, ["chainId"]);
            const contract = yield this.getContractByChainInfo(chainId);
            const req = yield contract.callSendMethod('RemoveManagerInfo', this.managementAccount.address, contractParams, sendOption);
            if (req.error)
                throw req.error;
            // delete current manager
            if (((_a = params.managerInfo) === null || _a === void 0 ? void 0 : _a.address) === this.managementAccount.address &&
                this.caInfo[chainId].caHash === params.caHash) {
                this.caInfo = {};
                this.accountInfo = {};
            }
            if ((sendOption === null || sendOption === void 0 ? void 0 : sendOption.onMethod) === 'transactionHash')
                return req;
            return req.data;
        });
    }
    getHolderInfo(params) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            const { manager, chainId } = params, managerInfo = __rest(params, ["manager", "chainId"]);
            if (manager || (!managerInfo.caHash && !managerInfo.loginGuardianIdentifier)) {
                let _manager = manager;
                if (!_manager && this.managementAccount)
                    _manager = this.managementAccount.address;
                if (!_manager)
                    throw new Error('not manager');
                const req = yield this.services.getHolderInfoByManager({ manager: _manager, chainId });
                const info = req[0];
                // get current manager info
                if (info && _manager === ((_a = this.managementAccount) === null || _a === void 0 ? void 0 : _a.address) && info.caAddress && info.caHash) {
                    this.caInfo[info.chainId || chainId] = { caAddress: info.caAddress, caHash: info.caHash };
                    const loginAccount = (_c = (_b = info.loginGuardianInfo[0]) === null || _b === void 0 ? void 0 : _b.loginGuardian) === null || _c === void 0 ? void 0 : _c.identifierHash;
                    if (!this.accountInfo.loginAccount && loginAccount)
                        this.accountInfo = { loginAccount: loginAccount };
                }
                return req;
            }
            else {
                const result = yield this.services.getHolderInfo(Object.assign(Object.assign({}, params), { guardianIdentifier: params.loginGuardianIdentifier }));
                // get current account info
                if (result && (result === null || result === void 0 ? void 0 : result.caHash) === ((_e = (_d = this.aaInfo) === null || _d === void 0 ? void 0 : _d.accountInfo) === null || _e === void 0 ? void 0 : _e.caHash)) {
                    const { caAddress, caHash } = result;
                    this.caInfo[chainId] = { caAddress, caHash };
                }
                return result;
            }
        });
    }
    getHolderInfoByContract(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const contract = yield this.getContractByChainInfo(params.chainId);
            const req = yield contract.callViewMethod('GetHolderInfo', { caHash: params.caHash });
            if (req.error)
                throw req.error;
            return req.data;
        });
    }
    getChainsInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            const chainList = yield this.services.getChainsInfo();
            const chainsInfo = {};
            chainList.forEach(chainInfo => {
                chainsInfo[chainInfo.chainId] = chainInfo;
            });
            this.chainsInfo = chainsInfo;
            return this.chainsInfo;
        });
    }
    logout(params, sendOption) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.managementAccount)
                throw new Error('ManagerAccount does not exist, please login.');
            if (!this.chainsInfo)
                yield this.getChainsInfo();
            if (!params.caHash && this.caInfo[params.chainId])
                params.caHash = this.caInfo[params.chainId].caHash;
            if (!params.managerInfo)
                params.managerInfo = {
                    address: this.managementAccount.address,
                    extraData: 'extraData',
                };
            if (!params.caHash)
                throw new Error('caHash does not exist');
            const req = yield this.removeManager(params, sendOption);
            return { status: req === null || req === void 0 ? void 0 : req.Status, transactionId: (req === null || req === void 0 ? void 0 : req.transactionId) || (req === null || req === void 0 ? void 0 : req.TransactionId) };
        });
    }
    getCAHolderInfo(originChainId) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.connectServices)
                throw new Error('connectServices does not exist');
            if (!this.managementAccount)
                throw new Error('managerAccount does not exist');
            const caHash = (_a = this.caInfo[originChainId]) === null || _a === void 0 ? void 0 : _a.caHash;
            const caAddress = (_b = this.caInfo[originChainId]) === null || _b === void 0 ? void 0 : _b.caAddress;
            if (!caHash)
                throw new Error('caHash does not exist');
            const timestamp = Date.now();
            const message = Buffer.from(`${this.managementAccount.address}-${timestamp}`).toString('hex');
            const signature = this.managementAccount.sign(message).toString('hex');
            const pubkey = this.managementAccount.wallet.keyPair.getPublic('hex');
            const config = {
                grant_type: 'signature',
                client_id: 'CAServer_App',
                scope: 'CAServer',
                signature: signature,
                pubkey,
                timestamp,
                ca_hash: caHash,
                chain_id: originChainId,
            };
            const info = yield this.connectServices.getConnectToken(config);
            const caHolderInfo = yield this.services.getCAHolderInfo(`Bearer ${info.access_token}`, caHash);
            if (caHolderInfo.nickName) {
                this.accountInfo = Object.assign(Object.assign({}, this.accountInfo), { nickName: caHolderInfo.nickName });
                this.aaInfo = Object.assign(Object.assign({ accountInfo: { caHash, caAddress } }, this.aaInfo), { nickName: caHolderInfo.nickName });
                this.originChainId = originChainId;
            }
            return caHolderInfo;
        });
    }
    signTransaction(tx) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.managementAccount)
                throw new Error('managerAccount does not exist');
            return this.managementAccount.signTransaction(tx);
        });
    }
    sign(data) {
        if (!this.managementAccount)
            throw new Error('managerAccount does not exist');
        return this.managementAccount.sign(data);
    }
    encrypt(password, options) {
        if (!this.managementAccount)
            throw new Error('managerAccount does not exist');
        return this.managementAccount.encrypt(password, options);
    }
    aesEncrypt(password) {
        if (!this.managementAccount)
            throw new Error('managerAccount does not exist');
        return AElf.wallet.AESEncrypt(this.managementAccount.privateKey, password);
    }
    create() {
        this.managementAccount = this._accountProvider.create();
        return this;
    }
    createByPrivateKey(privateKey) {
        this.managementAccount = this._accountProvider.privateKeyToAccount(privateKey);
        return this;
    }
    save(password, keyName) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._storage)
                throw new Error('Please set storage first');
            const aesPrivateKey = yield this.aesEncrypt(password);
            const data = JSON.stringify({
                aesPrivateKey,
                caInfo: this.caInfo,
                accountInfo: this.accountInfo,
                aaInfo: this.aaInfo,
                originChainId: this.originChainId,
                isLoginStatus: this.isLoginStatus,
                sessionId: this.sessionId,
            });
            const aesStr = aes.encrypt(data, password);
            yield this._storage.setItem(keyName !== null && keyName !== void 0 ? keyName : this._defaultKeyName, aesStr);
            return true;
        });
    }
    load(password, keyName) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._storage)
                throw new Error('Please set storage first');
            const aesStr = yield this._storage.getItem(keyName !== null && keyName !== void 0 ? keyName : this._defaultKeyName);
            if (aesStr) {
                const data = aes.decrypt(aesStr, password);
                if (data) {
                    const { aesPrivateKey, caInfo, accountInfo, aaInfo, originChainId, isLoginStatus, sessionId } = JSON.parse(data);
                    const privateKey = aes.decrypt(aesPrivateKey, password);
                    if (aesPrivateKey && privateKey) {
                        this.managementAccount = yield this._accountProvider.privateKeyToAccount(privateKey);
                        this.caInfo = caInfo || {};
                        this.accountInfo = accountInfo || {};
                        this.aaInfo = aaInfo || {};
                        this.originChainId = originChainId;
                        this.isLoginStatus = isLoginStatus;
                        this.sessionId = sessionId;
                    }
                }
            }
            return this;
        });
    }
    reset() {
        this.contracts = {};
        this.caInfo = {};
        this.accountInfo = {};
        this.aaInfo = {};
        this.managementAccount = undefined;
        this.isLoginStatus = LoginStatusEnum.INIT;
    }
    checkManagerIsExistByGQL(params) {
        return __awaiter(this, void 0, void 0, function* () {
            // Check if manager exists via GQL
            const resultByQGL = yield this.services.getHolderInfoByManager({
                manager: params.managementAddress,
                chainId: params.chainId,
                caHash: params.caHash,
            });
            const info = resultByQGL[0];
            const res = Boolean(info && info.caAddress);
            if (res) {
                this.updateLoginStatus(LoginStatusEnum.SUCCESS);
            }
            return res;
        });
    }
    checkManagerIsExistByContract(params) {
        return __awaiter(this, void 0, void 0, function* () {
            // Check if manager exists via Contract
            const resultByContract = yield this.getHolderInfoByContract({
                caHash: params.caHash,
                chainId: params.chainId,
            });
            const managerInfos = resultByContract.managerInfos;
            const isExist = managerInfos === null || managerInfos === void 0 ? void 0 : managerInfos.some(manager => (manager === null || manager === void 0 ? void 0 : manager.address) === params.managementAddress);
            return Boolean(isExist);
        });
    }
    checkManagerIsExist(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.checkManagerIsExistByGQL(params)) || (yield this.checkManagerIsExistByContract(params));
        });
    }
    updateLoginStatus(params) {
        this.isLoginStatus = params;
    }
    checkStorageAesStrIsExist(keyName) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._storage)
                throw new Error('Please set storage first');
            const aesStr = yield this._storage.getItem(keyName !== null && keyName !== void 0 ? keyName : this._defaultKeyName);
            return Boolean(aesStr);
        });
    }
    sendMultiTransaction(params) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const { chainId, multiChainInfo, gatewayUrl, params: multiTransactionParamInfo } = params;
            if (!((_a = this.managementAccount) === null || _a === void 0 ? void 0 : _a.privateKey))
                throw new Error('Please login first');
            if (!this.chainsInfo)
                yield this.getChainsInfo();
            const chainInfo = (_b = this.chainsInfo) === null || _b === void 0 ? void 0 : _b[chainId];
            if (!chainInfo)
                throw new Error(`${chainId} chainInfo does not exist`);
            const transformedMultiChainInfo = Object.entries(multiChainInfo).reduce((acc, [key, value]) => {
                const chainId = ChainIdMap[key];
                if (chainId) {
                    acc[chainId] = value;
                }
                return acc;
            }, {});
            const aelfInstance = aelf.getAelfInstance(chainInfo.endPoint);
            const wallet = aelf.getWallet(this.managementAccount.privateKey);
            const contractOption = {
                multi: transformedMultiChainInfo,
                gatewayUrl,
            };
            const caContract = yield aelfInstance.chain.contractAt(chainInfo.caContractAddress, wallet, contractOption);
            const transformedParams = Object.entries(multiTransactionParamInfo).reduce((acc, [key, value]) => {
                const chainId = ChainIdMap[key];
                if (chainId) {
                    acc[chainId] = value;
                }
                return acc;
            }, {});
            return yield caContract.sendMultiTransactionToGateway(transformedParams);
        });
    }
}
